<template>
  <div>
    <p>
      copyRight@jinxiaochi.github.io<br/>
      <!--2020.04.30<br/>-->
    </p>
    <p>

    </p>
  </div>

</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue